export function  jsonRequest(url, options) {
    const opts = {
        ...options,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            ...(options ? options.headers : {})
        }
    };

    return request(url, opts)
        .then((response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json()
        })
        .catch((error) => {
            console.info('There has been a problem with your fetch operation: ', error.message)
        });

}

export function request(url, options) {
    const opts = {
        credentials: 'include',
        ...options,
        body: (options && options.body) ? JSON.stringify(options.body) : undefined,
    };
    return fetch(url, opts);
}
